import React from "react";
import Grid from "../../partials/content/Grid";
import { Table } from "react-bootstrap";
import { getJobDPServices } from "../../crud/auth.crud";
import EditIcon from '@material-ui/icons/Edit';
 import { Link } from "react-router-dom";
 import { Tooltip } from "@material-ui/core";
 import { IconButton } from '@material-ui/core';
 

export default class JobServices extends React.Component {
  state = {
    services:[]
  }
  componentDidMount()
  {
    
    getJobDPServices().then(response => response.data)
    .then((data) => {
      this.setState({ services: data })
      //console.log(this.state.users)
     })
  }
  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <Grid beforeCodeTitle="Digital Planning Packages" jsCode="true" createPath="/createjobservice">
              <div className="kt-section">
               
                <Table striped bordered hover>
                  <thead>
                    <tr>
                     
                      <th>Service</th>
                      <th>Description</th>
                      <th>Amount</th>
                      <th>Edit</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                  {this.state.services!=null && this.state.services.map((service) => (
                    <tr>
                      
                      <td>{service.serviceType} </td>
                      <td>{service.serviceTypeDescription}</td>
                      <td>{'$'+service.price}</td>
                      <td>
                          
                          <Link  to={{pathname:"/editjobservice", data: {service:service}}}>
                           <Tooltip
                                    title="Edit Service" 

                                  >
                            <IconButton>
                              <EditIcon style={{ color: '#5578eb',fontSize: 12}}/>   
                            </IconButton>
                            </Tooltip>
                          </Link>
                          
                      </td>
                    </tr>
                    ))}
                </tbody>
                </Table>
              </div>
            </Grid>
          </div>
         
        </div>

      

       
      </>
    );
  }
}
